import React from 'react';
import styled from '@emotion/styled';

import CreatorProfileCard from './CreatorProfileCard';

function CreatorProfileCards({ creators }) {
  return (
    <ProfileLandingPlates className="profile-landing-templates">
      <Container className="m-auto grid gap-4 lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-2">
        {creators.map(profile => (
          <CreatorProfileCard
            profile={profile}
            page={`https://invideo.io/creator/${profile.username}`}
            key={profile.id}
          />
        ))}
      </Container>
    </ProfileLandingPlates>
  );
}

export default CreatorProfileCards;

const ProfileLandingPlates = styled.div`
  padding-bottom: 100px;
`;

const Container = styled.div`
  padding-top: 1rem;
  max-width: 1200px;
  height: 100%;
`;
